import { EventContext, Fields } from '@vimeo/bigpicture-client';

import { createNullObject, PartialWithRequired } from './utils';

export const videoBpContextName = 'video_context';
export const videoBpContextSchemaVersion = 7;
export type VideoBpContext = Fields<typeof videoBpContextName, typeof videoBpContextSchemaVersion>;

const defaults = createNullObject([
  'content_rating',
  'duration',
  'is_auto_cc_enabled',
  'is_demo',
  'orientation',
  'resolution',
  'title',
  'upload_method_api',
  'upload_method_api_id',
  'video_embed_privacy',
  'video_height',
  'video_owner_id',
  'video_privacy',
  'video_width',
  'has_embed_available',
  'video_categories',
  'video_version_id',
  'existing_like_counts',
  'existing_comment_counts',
  'existing_view_counts',
  'listed_categories_counts',
  'has_like_available',
  'has_watch_later_available',
  'has_share_available',
  'has_embed_available',
  'viewer_home_session_id',
]);

export const buildVideoBpContext = (fields: PartialWithRequired<VideoBpContext, 'video_id'>) => {
  return {
    video_context: new EventContext(videoBpContextName, videoBpContextSchemaVersion, {
      ...defaults,
      ...fields,
    }),
  };
};
